import axios from 'api';
import {ActionTypes} from '../types';
import {setAlert} from './alertActions';
import {setInterceptor} from 'core/utils/setAuthConfig';
import {loadControlItems} from './setupActions';
import {clearCustomStore} from 'custom/common/redux/actions';
import { sendTrackingInfo } from 'core/api/trackingWebService';

//LoginTracking
const trackLoginUser = async (user) => {
  const {trackingUserName, username} = user;
  sessionStorage.setItem('globalPageNumber', 0);
  const trackingData = {
    detail: {
      formName: 'ProQuote',
      CurrentField: 'btnLogin',
      txtProQuotePageNumber: `0`
    },
    header: {
      agentID: '',
      eventType: 'PQ_START',
      formName: 'ProQuote',
      name: 'ProQuoteStart',
      timestamp: Math.trunc(Date.now() / 1000),
      username: trackingUserName,
      loginUserName: username
    },
  };
  await sendTrackingInfo(trackingData);
};

// Login User
let cancelToken;
export const login = (username, password) => async (dispatch, getState) => {
  if (typeof cancelToken != typeof undefined) {
    cancelToken.cancel('Operation canceled due to new request.');
  }
    cancelToken = axios.CancelToken.source();
  var generateTrackingUserName = true;
  const body = { username, password, generateTrackingUserName};
  try {
    const {data} = await axios.post('/users/authenticateProQuote', body, {cancelToken: cancelToken.token});
    console.log('Auth tokens: ', data);
    data.user.trackingUserName = data.trackingUserName; //In case the back-end is not doing this for us

    sessionStorage.setItem('quote-rt', JSON.stringify(data));
    // setAuthToken(data.jwt);
    setInterceptor();
    dispatch({type: ActionTypes.AUTH_SUCCESS, payload: data});
    
    dispatch({
      type: ActionTypes.LOGIN_SUCCESS,
      payload: data.user,
    });
    trackLoginUser(data.user);
    if (data['fontSize'] === 'Large') {
      document.body.classList.add('altFont');
    } else if (data['data'] === 'Small') {
      document.body.classList.remove('altFont');
    }
    if (!getState().setupItems.controlItems) {
      dispatch(loadControlItems());
    }
    
  } catch (error) {
    dispatch({type: ActionTypes.AUTH_FAIL});
    if (error && error.response) {
      dispatch(setAlert(error.response.data['message'], 'Error', 'login'));
    }
    console.log(error);
  }
};

//Update user profile field
export const updateUserProfileField = (fieldName, value) => async (dispatch, getState) => {
  let user = {...getState().auth.user};
  const isAuthenticated = getState().auth.isAuthenticated;

  if (isAuthenticated) {
    user[fieldName] = value;
    try {
      const res = await axios.post('/users/update', user);
      dispatch({
        type: ActionTypes.UPDATE_PROFILE,
        payload: res.data,
      });
    } catch (error) {
      if (error && error.response) {
        console.log(error.response.data);
      }
    }
  }
};

//Update User Profile
export const updateUserProfile = (formData, t) => async (dispatch, getState) => {
  let user = {...getState().auth.user};
  const isAuthenticated = getState().auth.isAuthenticated;

  if (isAuthenticated) {
    user['profileName'] = formData['txtUserName'];
    user['emailAddress'] = formData['txtEmailAddress'];
    user['phoneNumberPrimary'] = formData['txtPrimaryPhone'];
    user['phoneNumberSecondary'] = formData['txtSecondaryPhone'];
    user['faxNumber'] = formData['txtFaxNumber'];
    user['isMobilePrimary'] = formData['chkPrimaryPhone'];
    user['isMobileSecondary'] = formData['chkSecondaryPhone'];
    user['inputLanguage'] = formData['rdoInputLanguage'];
    user['reportLanguage'] = formData['rdoReportLanguage'];
    user['fontSize'] = formData['rdoFontSize'];
    user['defaultApplication'] = formData['rdoDefaultApp'];
    user['formData'] = {};

    try {
      const res = await axios.post('/users/update', user);
      dispatch({
        type: ActionTypes.UPDATE_PROFILE,
        payload: res.data,
      });
      dispatch(setAlert(t('msg-InfoUpdatedSaved'), 'Success', 'updateProfile'));
    } catch (error) {
      dispatch(setAlert(error.response.data['message'], 'Error', 'updateProfile', 5000));
      console.log(error.response.data);
      // dispatch({type: ActionTypes.LOGIN_FAIL});
    }
  }
};

//Api for only Admin user
export const getAllUsers = (updatedUser) => async (dispatch, getState) => {
  let res;
  try {
    res = await axios.get('/users');
    console.log(res.data);
    dispatch({type: ActionTypes.ALL_USERS, payload: res.data});
  } catch (error) {
    if (error.response) {
      console.log(error.responderEnd);
    }
  }

  if (updatedUser) {
    const currentUser = getState().auth.user;
    if (currentUser.username === updatedUser.username) {
      updatedUser.formData = {...currentUser.formData};
      updatedUser.system = {...currentUser.system};
      dispatch({
        type: ActionTypes.UPDATE_PROFILE,
        payload: updatedUser,
      });
    }
  }
};

// Logout / Clear Profile
export const logout = (callApi = true) => async (dispatch) => {
  let token = JSON.parse(sessionStorage.getItem('quote-rt'));

  dispatch({type: ActionTypes.REMOVE_ALERT, name: 'updateProfile'});
  dispatch({type: ActionTypes.LOGOUT});
  dispatch({type: ActionTypes.CLEAR_PROFILE});
  dispatch({type: ActionTypes.CLEAR_FORMDATA, payload: {}});
  dispatch({type: ActionTypes.DATA_REMOVE});
  dispatch(clearCustomStore());
  if (callApi && token) {
    try {
      await axios.post('/users/logout', token);
    } catch (error) {
      console.log(error);
    }
  }
};

// Session Timeout
export const sessionTimeout = () => async (dispatch) => {
  let token = JSON.parse(sessionStorage.getItem('quote-rt'));
  console.log('sessionTimeout');
  try {
    if (token) {
      await axios.post('/users/logout', token);
    }
  } catch (error) {
    console.log(error);
  }
  // dispatch({type: ActionTypes.DATA_REMOVE});
  dispatch({type: ActionTypes.SESSION_TIMEOUT});
};
